export default {
  title: 'Kies het pakket wat',
  title_light: ' het beste bij jou past!',
  subtitle: 'jouw Stichting voor',
  description:
    'Bespaar tijd en geld door toegang tot 100+ juridische documenten en onbeperkt telefonische consults met gespecialiseerde advocaten'
};
